import React from 'react';
import Helmet from 'react-helmet';

const MetaInfo = (props) => {

    return (
        <>
            {props.lang !== 'fr' ?
                <Helmet>
                    <title>Our Pork Guarantee</title>
                    <meta name="description" content="A&W is the first North American restaurant chain to serve pork that’s raised without the use of antibiotics." />
                </Helmet>
            :
                <Helmet>
                    <title>La garantie sur notre porc</title>
                    <meta name="description" content="A&W est la première chaîne de restaurants en Amérique du Nord à servir du porc élevé sans antibiotiques." />
                </Helmet>
            }
        </>
    )
}
export default MetaInfo;